import * as THREE from 'three';
import { WindowService } from './WindowService';
import { DebugService } from './DebugService';
import { TickService } from './TickService';
import { SizesInterface } from './WindowService';
import { LoaderController } from './LoaderService';
import { LightingService } from './LightingService';
import { CameraService } from '../core/CameraService';
import { ExerciseScene } from '../ExerciseScene';
import { FlutterBridgeService } from '../st/FlutterBridgeService';
import { TweenService } from './TweenService';
import { CharacterAnimatorService } from '../st/CharacterAnimatorService';
import { CharacterService } from '../st/CharacterService';
import { UIService } from '../st/UIService';

export class Core {
	/**
	 * Core Properties
	 * */
	sizes: SizesInterface;
	windowSizer: WindowService;
	canvas: HTMLCanvasElement;
	scene: THREE.Scene;
	exerciseScene: ExerciseScene;
	renderer: THREE.WebGLRenderer;

	/**
	 * Services
	 * */
	services: any[] = [];

	/**
	 * Debug mode
	 * */
	debugMode: boolean;

	/**
	 * Constructor
	 * */
	constructor(canvas: HTMLCanvasElement, sizes: SizesInterface, debugMode: boolean = false) {
		this.debugMode = debugMode;
		this.canvas = canvas;
		this.sizes = sizes;
		this.scene = new THREE.Scene();
		this.scene.background = new THREE.Color('#F4F2E4');
		this.renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true });
		this.renderer.outputColorSpace = THREE.SRGBColorSpace; // || LinearSRGBColorSpace

		// Add debug services if required
		if (debugMode) {
			this.registerService('Debug', new DebugService(this, debugMode));
		}

		// Register core services
		this.registerService('Loader', new LoaderController());
		this.registerService('FlutterBridge', new FlutterBridgeService(this));
		this.registerService('Lighting', new LightingService(this));
		this.registerService('Camera', new CameraService(this));
		this.registerService('Tick', new TickService(this));
		this.registerService('Tween', new TweenService(this));
		this.registerService('Character', new CharacterService(this));
		this.registerService('CharacterAnimator', new CharacterAnimatorService(this));
		this.registerService('UI', new UIService(this));

		// Watch the screen
		this.windowSizer = new WindowService(this);
		this.windowSizer.resize();
		this.windowSizer.watchResize();

		// Load the scene
		this.exerciseScene = new ExerciseScene(this);

		return this;
	}

	/**
	 * Returns a Service
	 * @param {string} serviceName The name of a service
	 * */
	s(serviceName: string) {
		try {
			return this.services.find((s) => s.name == serviceName).instance;
		} catch(e) {
			console.log(`Cannot load service: ${serviceName}`);
		}
	}

	/**
	 * Registers a manager that will be accessible to the main scope
	 * */
	registerService(serviceName: string, instance: any) {
		this.services.push({ name: serviceName, instance: instance });
	}
}
